import { type PropsWithChildren, useRef } from 'react';

import { createStore, Store } from '../../../core/store/store.js';
import { initialState } from '../constants/defaults.js';
import { XYChartStoreContext } from '../context/XYChartStore.context.js';
import { useXYChartData } from '../hooks/useXYChartData.js';
import type { XYChartState } from '../types/state.js';
import { getCurrentDomainMap } from '../utils/get-current-domain-axis.js';
import { isZoomOutAllowed } from '../utils/is-zoom-out-allowed.js';

export const XYChartStoreProvider = ({ children }: PropsWithChildren) => {
  const storeRef = useRef<Store<XYChartState>>(undefined);
  const { axesMetadata, axes, axisIdToScaleDomain } = useXYChartData();

  const currentDomainMap = getCurrentDomainMap(axes);
  const zoomOutAllowed = isZoomOutAllowed(axes, axisIdToScaleDomain);

  const lastInteraction = storeRef?.current?.getState().interactionMode;

  storeRef.current = createStore({
    ...initialState,
    interactionMode: lastInteraction || 'explore',
    zoom: {
      ...initialState.zoom,
      zoomOutEnabled: axesMetadata.isInfinite || zoomOutAllowed,
    },
    currentDomain: currentDomainMap,
  });

  return (
    <XYChartStoreContext.Provider value={storeRef.current}>
      {children}
    </XYChartStoreContext.Provider>
  );
};
